<template>
    <div v-if="!isBaseExExist" style="display: flex;flex-direction: column;align-items: center;">
        <n-alert  type="info" style="margin-bottom: 20px;">
            {{ $t('coupons_text8') }}
        </n-alert>
        <base-ex ref="baseEXE" style="width: 311px;"></base-ex>
        <n-button type="info" @click="validForm()" :disabled="!isFormFinsh">{{ $t('event5_text7') }}</n-button>
    </div>
    <div v-else style="display: flex;align-items: center;flex-direction: column;">
        <h2 style="margin-top: 0;">{{ $t('event5_text1') }}</h2>
        <n-qr-code :value="qrcodeText" size="200"/>
        <div style="text-align: center;margin: 15px 0 50px 0;font-size: 15px;padding: 0 8px;"  v-html="$t('event5_text2')"></div>
        <div style="width: 270px;text-align: center;">
            <h3>{{ $t('event5_text3') }}</h3>
            <div style="margin-bottom: 6px;">{{$t('event5_text4')}} <b style="font-size: 17px;color: #00bcd4;">{{ referralInfo.usage }}</b> {{$t('event5_text6')}}</div>
            <br>
            <span v-if="irsInfo && referralInfo.usage > 0 && !isExp(irsInfo.exp)" style="margin-bottom: 6px;">
                <span v-html="$t('event5_text5')"></span>
                <b style="font-size: 17px;color: #00bcd4;">{{dateFormat(irsInfo.exp)}}</b>
            </span>
            <span v-else style="font-size: 30px;text-align: center;color: rgb(0, 188, 212);">
                {{$t('event5_text10')}}
            </span>
        </div>
    </div>
</template>
<script>
// import QRCode from 'qrcodejs2-fix'
// import { defineComponent, onMounted, nextTick, ref } from 'vue'
import { defineComponent, ref, computed, inject } from 'vue'
import { useStore } from "vuex"
import baseex from '@/components/baseEX.vue'
import { useI18n } from "vue-i18n"

export default defineComponent({
    components: {
        'base-ex': baseex
    },
    setup() {
        const i18n = useI18n()
        const { t } = i18n
        const changeSpinState = inject('changeSpinState')
        const store = useStore()
        var lang = i18n.locale.value
        let userInfo = store.state.coreApi.userInfo
        const referralInfo = store.getters["coreApi/referralInfo"];
        const baseEXCheckKey = computed(() => store.getters["coreApi/baseEXCheckKey"]);
        const baseEx = computed(() => store.getters['coreApi/baseEx']);
        const benifits = store.getters["coreApi/benifits"];
        let irsInfo = benifits.hiteach.find( x => x.func === "webirs" )
        const qrcodeText = ref(`${document.location.origin}/exginvcode/${lang}/${referralInfo.code}?o=1&m=${t('event5_text8')} ${userInfo.id}(${userInfo.name}) ${t('event5_text9')} `);
        const baseEXE = ref()


        // 判斷是否有填寫進階資訊
        const isBaseExExist = computed(()=>{
            let isExist = true

            if(baseEx.value){
                baseEXCheckKey.value.forEach(c=>{
                    switch(c){
                        case 'country':{
                                let pattern_En = new RegExp("[A-Za-z]")
                                if (!pattern_En.test(baseEx.value[c])) {
                                    isExist = false
                                }
                            }
                            break
                        case 'schoolCode':
                        // 暫不檢查
                        //     if(baseEx.value['country'] == 'TW' && (baseEx.value[c] == '' || baseEx.value[c] == null)){
                        //         isExist = false
                        //     }
                        break
                        default:
                            if(baseEx.value[c] == '' || baseEx.value[c] == null) {
                                isExist = false
                            }
                    }
                })
            } else {
                isExist = false
            }
            return isExist
        })

        const dateFormat = (val)=>{
            let time = val
            if(val.toString().length < 13) {
                time = time * 1000
            }

            return new Date(parseInt(time)).toISOString().split('T')[0].replaceAll('-', '/')
        }

        const isExp = (val) => {
            let now = new Date().getTime()
            let tmp = val
            if(val.toString().length < 13) tmp = tmp * 1000
            return now > tmp
        }

        // 設定都完成按鈕亮燈
        const isFormFinsh = computed(()=>{
            let flag = true
            baseEXCheckKey.value.forEach(c=>{
                switch(c){
                    case 'schoolCode':
                        // 暫不檢查
                        // if(baseEXE.value?.baseExValue['country'] == 'TW' && (baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null)){
                        //     flag = false
                        // }
                    break
                    default:
                        if(baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null) {
                            flag = false
                        }
                }
            })
            return flag
        })

        const validForm = ()=>{
            baseEXE.value.baseExFormRef.validate(
                async(errors) => {
                    if (!errors) {
                        changeSpinState() // 開啟全屏spin
                        let data = {}
                        if(baseEx.value){
                            let bKeys = Object.keys(baseEx.value)

                            bKeys.forEach(k=>{
                                if(baseEXE.value.baseExValue[k]) {
                                    data[k] = baseEXE.value.baseExValue[k]
                                } else {
                                    data[k] = baseEx.value[k]
                                }
                            })
                        } else {
                            data = baseEXE.value.baseExValue
                        }

                        // 寫入baseEX
                        await store.dispatch('coreApi/setUserContact', data).then(() => {
                            changeSpinState() // 關閉全屏spin
                        }).catch(e =>{
                            console.log(e)
                        })
                    }
                }
            )
        }

        return {
            referralInfo,
            irsInfo,
            dateFormat,
            qrcodeText,
            isBaseExExist,
            validForm,
            baseEXE,
            isFormFinsh,
            isExp
        }
    }
})
</script>
<style lang="less" scoped>
</style>